import axios from "axios";

export default {
	listDistricts(ctx, preload) {
		if (preload != undefined) {
			ctx.p = preload;
		}
		return axios.get("/v3/districts", { params: ctx });
	},

	getDistrict(id, preload) {
		var ctx;
		if (preload != undefined) {
			ctx = { p: preload };
		}
		return axios.get(`/v3/district/${id}`, { params: ctx });
	},

	saveDistrict(district) {
		return axios.post("/v3/district", district);
	},

	removeDistrict(id) {
		return axios.delete(`/v3/district/${id}`);
	},
	getPublicDistricts(ref_id) {
		let config = {};
		config.headers = { "X-No-Timeout": true };
		return axios.get(`/v3/public_districts/${ref_id}`,config);
	}
};



// WEBPACK FOOTER //
// ./src/services/DistrictService.js